import { useLocalStorage } from "usehooks-ts";

export const useFlowNavSidebarCollapsed = () =>
  useLocalStorage("flowDetailNavigationCollapsed", false);
